import { useStore } from "zustand";
const createBoundedUseStore = (store) => (selector) => useStore(store, selector);
export {
  createBoundedUseStore
};
//# sourceMappingURL=create-bounded-use-store.js.map
